
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightSleetColour as ObiLightSleetColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-sleet-colour.js';
 
 
 

 
 export const ObiLightSleetColour = createComponent({
   react: React,
   tagName: 'obi-light-sleet-colour',
   elementClass: ObiLightSleetColourElement,
   events: {
     
   }
  });
 
 